import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';

export const MobileAppConvenienceSheetTexts = {
  title: 'Почему в приложении удобнее',
  questionnaire: `Анкета сохраняется, не${UNBREAKABLE_SEPARATOR}нужно заполнять заново`,
  status: 'Статус заявки виден сразу',
  products: `Займы, кредиты и${UNBREAKABLE_SEPARATOR}страховки в${UNBREAKABLE_SEPARATOR}одном месте`,
  reminder: 'Напомним, когда подойдёт срок платежа',
  continueInApp: 'Продолжить в приложении',
};
